import { render } from "./SideBarButton.vue?vue&type=template&id=f739c868&scoped=true"
import script from "./SideBarButton.vue?vue&type=script&lang=js"
export * from "./SideBarButton.vue?vue&type=script&lang=js"

import "./SideBarButton.vue?vue&type=style&index=0&id=f739c868&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f739c868"]])

export default __exports__